import { Injectable } from "@angular/core";
import { PostProcessor, PostProcessorType } from "../post-processor";
import { LogicService } from "../../logic/logic.service";
import { LoggingService } from "../../logging/logic/logging.service";
import { Servicejob } from "src/app/_model/servicejob";
import { UpdateModelObjectService } from "../../update-model-object/update-model-object.service";
import { PostProcessorParameterXML, PostProcessorXML } from "src/app/_model/dyn-form/dyn-form-xml";
import { DynForm } from "src/app/_model/dyn-form";
import { IMSId, IMSObject, IMSObjectType } from "src/app/_model/ims-object";
import { AbstractFormFieldXML } from "src/app/_model/dyn-form/form-fields/abstract-form-field-xml";
import { ServicejobsService } from "../../servicejobs/logic/servicejobs.service";
import { RemoteActionUpdateObject } from "src/app/_model/remote-action/remote-action-builder/remote-action-builder";

@Injectable({
    providedIn: 'root'
})
export class UpdateModelObjectPostProcessor implements PostProcessor {
    // Public Member
    constructor(
        private serviceJobService: ServicejobsService,
        private updateModelObjectService: UpdateModelObjectService,
        private logger: LoggingService,
    ) {

    }
    public readonly name: PostProcessorType = 'updatemodelobject';

    // Lifecycle
    async postProcess(form: DynForm, formData: any, imsObject: IMSObject, postProcessorXml: PostProcessorXML): Promise<RemoteActionUpdateObject[]> {
        this.logger.log(this.constructor.name, ' postProcess with parameters -> form:', form, ' formData:', formData, ' imsObject:', imsObject, ' postProcessorXml:', postProcessorXml)
        if (form && formData && imsObject && postProcessorXml) {
            if (postProcessorXml.param) {
                let fieldNameToNewValueMap = postProcessorXml.param instanceof Array ? await this.resolveParametersForModelObject(formData, postProcessorXml.param) : await this.resolveParametersForModelObject(formData, [postProcessorXml.param])
                await this.updateModelObjectService.updateModelObject(imsObject,fieldNameToNewValueMap)
                this.logger.log(this.constructor.name, ' completed postProcess');
            }
        }
        return undefined
    }

    async resolveParametersForModelObject(formData: any, postProcessorParameters: PostProcessorParameterXML[]): Promise<Map<string, any>> {
        let fieldNameToNewValueMap = new Map()
        if (formData) {
            postProcessorParameters.forEach(parameter => {
                let associatedFieldDefValue = formData[parameter.$?.associatedfield.valueOf()]
                let parameterName = parameter.$?.name.valueOf();
                if (associatedFieldDefValue && parameterName) {
                    fieldNameToNewValueMap.set(parameterName, associatedFieldDefValue)
                } else {
                    this.logger.log(this.constructor.name, ' Could not find associatedField value in formData:', formData, ' for the parameter: ', parameter)
                }
            })
            return fieldNameToNewValueMap
        } else {
            return undefined
        }
    }
}